import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

// Typed confirmation gate for multi-staff imports (§18). The user must type
// GENERATE CLASSES to enable the confirm button — deliberate friction so a
// misclick can't launch a production write across many staff.
type Props = {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
};

const PHRASE = "GENERATE CLASSES";

export default function ConfirmAllModal({ open, count, onClose, onConfirm }: Props) {
  const [typed, setTyped] = useState("");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm bulk import</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          You are about to generate classes for <b>{count} active staff members</b>.
          This will write production class, schedule, enrolment, and occurrence data.
          Continue only after verifying sample staff imports.
        </Typography>
        <Alert severity="warning" sx={{ my: 2 }}>
          One failed staff will not stop the others — each staff runs in its own
          database transaction.
        </Alert>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Type <b>{PHRASE}</b> to enable the Run Import button.
        </Typography>
        <TextField
          fullWidth size="small" autoFocus value={typed}
          onChange={(e) => setTyped(e.target.value)}
          placeholder={PHRASE}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" disabled={typed !== PHRASE} onClick={onConfirm}>
          Run Import
        </Button>
      </DialogActions>
    </Dialog>
  );
}
